<template>
    <div class="token-admin">
      <h2>ERC20 Token Metadata</h2>
  
      <!-- Notification Banner -->
      <div v-if="notification.message" :class="['notification', notification.type]">
        {{ notification.message }}
        <button class="dismiss-btn" @click="clearNotification">×</button>
      </div>
  
      <div class="new-token-form">
        <input v-model="newToken.contract" placeholder="Contract Address" />
        <input v-model="newToken.symbol" placeholder="Token Symbol" />
        <input v-model.number="newToken.decimals" placeholder="Decimals" type="number" />
        <button @click="addToken">Add Token</button>
      </div>
  
      <input v-model="search" placeholder="Search by symbol or contract" class="search-box" />
  
      <table class="token-table">
        <thead>
          <tr>
            <th>Contract</th>
            <th>Symbol</th>
            <th>Decimals</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(entry) in filteredTokens" :key="entry.id">
            <td>{{ entry.contract_address }}</td>
            <td><input v-model="entry.token_symbol" /></td>
            <td><input v-model.number="entry.token_decimals" type="number" /></td>
            <td>
              <button @click="saveToken(entry)">💾 Save</button>
              <button @click="deleteToken(entry.id)">🗑 Delete</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </template>
  <script>
  import axios from 'axios';
  
  export default {
    name: 'TokenMetadataAdmin',
    data() {
      return {
        tokens: [],
        newToken: {
          contract: '',
          symbol: '',
          decimals: 18
        },
        search: '',
    notification: {
      message: '',
      type: '' // success or error
    }
      };
    },
    computed: {
      filteredTokens() {
        const q = this.search.toLowerCase();
        return this.tokens.filter(t =>
          t.contract_address.toLowerCase().includes(q) ||
          (t.token_symbol || '').toLowerCase().includes(q)
        );
      }
    },
    methods: {
        
  showNotification(message, type = 'success') {
    this.notification.message = message;
    this.notification.type = type;
    setTimeout(() => this.clearNotification(), 5000); // auto-clear after 5 sec
  },
  clearNotification() {
    this.notification.message = '';
    this.notification.type = '';
  },
  fetchTokens() {
  axios.get('etherscan/other/fetch_tokens.php', {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
  }).then(res => {
    this.tokens = res.data.tokens;
  }).catch(() => {
    this.showNotification('Failed to fetch tokens', 'error');
  });
},

addToken() {
  const { contract, symbol, decimals } = this.newToken;
  if (!contract || !symbol || decimals < 0) {
    this.showNotification('Invalid input for new token', 'error');
    return;
  }

  axios.post('etherscan/other/add_token.php', {
    contract_address: contract.toLowerCase(),
    token_symbol: symbol,
    token_decimals: decimals
  }, {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
  }).then(() => {
    this.newToken = { contract: '', symbol: '', decimals: 18 };
    this.showNotification('Token added');
    this.fetchTokens();
  }).catch(() => {
    this.showNotification('Failed to add token', 'error');
  });
},

saveToken(token) {
  axios.post('etherscan/other/update_token.php', token, {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
  }).then(() => {
    this.showNotification('Token updated');
    this.fetchTokens();
  }).catch(() => {
    this.showNotification('Failed to update token', 'error');
  });
},

deleteToken(id) {
  const token = this.tokens.find(t => t.id === id);
  if (!token) {
    this.showNotification('Could not find token to delete', 'error');
    return;
  }

  if (confirm('Delete this token?')) {
    axios.post('etherscan/other/delete_token.php', {
      contract_address: token.contract_address
    }, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    }).then(() => {
      this.showNotification('Token deleted');
      this.fetchTokens();
    }).catch(() => {
      this.showNotification('Failed to delete token', 'error');
    });
  }
}


    },
    mounted() {
      this.fetchTokens();
    }
  };
  </script>
  
  
  <style scoped>
  .token-admin {
    padding: 20px;
    max-width: 800px;
    margin: auto;
  }
  .token-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
  }
  .token-table th,
  .token-table td {
    padding: 8px;
    border: 1px solid #ccc;
  }
  .token-table input {
    width: 100%;
    padding: 4px;
  }
  .new-token-form {
    margin-bottom: 20px;
    display: flex;
    gap: 10px;
  }
  .search-box {
    margin-bottom: 10px;
    padding: 6px;
    width: 100%;
  }
  .notification {
  margin: 10px 0;
  padding: 10px 15px;
  border-radius: 5px;
  font-weight: bold;
  text-align: center;
}

.notification.success {
  background-color: #d4edda;
  color: #155724;
}

.notification.error {
  background-color: #f8d7da;
  color: #721c24;
}

.dismiss-btn {
  background: none;
  border: none;
  float: right;
  font-size: 16px;
  cursor: pointer;
  color: inherit;
}

  </style>
  